// extracted by mini-css-extract-plugin
export default {"betaBadge":"PremiumCard_betaBadge__np1Ek"};